const FEATURES_DATA = [
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '全网热点实时追踪，每日更新大量最新黑料吃瓜视频和短视频内容，确保您第一时间获取最新资讯。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清播放',
    desc: '所有黑料吃瓜在线观看视频均支持高清画质播放，流畅不卡顿，提供沉浸式观看体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持手机、平板、电脑全平台观看，一个账号多端同步，随时随地畅享黑料吃瓜内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '严格的审核机制和隐私保护策略，黑料吃瓜网在线观看环境安全纯净，让您放心浏览。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '社区互动',
    desc: '活跃的吃瓜社区氛围，与千万吃瓜群众一起讨论热门话题，分享你的独特观点。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-star-line text-primary-500 mr-2"></i>为什么选择我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">黑料吃瓜平台的五大核心优势</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES_DATA.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-100/70 border border-background-200/60 rounded-xl p-6 text-center hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className={`w-14 h-14 mx-auto rounded-2xl flex items-center justify-center mb-4 ${
                idx === 0 ? 'bg-primary-100' :
                idx === 1 ? 'bg-accent-100' :
                idx === 2 ? 'bg-secondary-100' :
                idx === 3 ? 'bg-primary-100' :
                'bg-accent-100'
              }`}>
                <i className={`${feature.icon} text-2xl ${
                  idx === 0 ? 'text-primary-500' :
                  idx === 1 ? 'text-accent-500' :
                  idx === 2 ? 'text-secondary-500' :
                  idx === 3 ? 'text-primary-500' :
                  'text-accent-500'
                }`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}